module.exports = __webpack_public_path__ + "img/phone.a4b2656.png";